<template>
  <div>
    <div tabindex="0" ref="modal" class="modal-mask"></div>

    <div class="modal-wrapper">
      <rare-modal-close-icon-large
        class="rareModalCloseIcon show-for-medium"
        @clicked="closeModal"
      />

      <rare-modal-close-icon-medium
        class="rareModalCloseIcon show-for-small-only"
        @clicked="closeModal"
      />

        <div class="modal-header">
          <div class="grid-container full">

            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15">
                <h1>{{ currentResearchPaper.title }}</h1>
              </div>
            </div>

          </div>
        </div>

        <div class="modal-body">
          <div class="grid-container full">

            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15">
                <p class="info">
                  {{ currentResearchPaper.subtitle }}
                  <br/><br/>
                  <strong>Date published:</strong><br class="show-for-small-only"/> {{ currentResearchPaper.date }}<br/>
                  <strong>Written by:</strong><br class="show-for-small-only"/> {{ currentResearchPaper.author }}
                </p>
              </div>
            </div>

            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15" style="display: flex; ">
               <div v-for="(item, index) in currentResearchPaper.pdf" v-bind:key="index">
                <a :href="currentResearchPaper.pdf[index]" target="_blank">
                <img
                  class='research-image'
                  :src='currentResearchPaper.image[index]' />
               </a>
               </div>
              </div>
            </div>

            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15">
                <hr/>
              </div>
            </div>

            <div v-if="currentResearchPaper.tag !== ''" class="grid-x">
              <div class="small-12 medium-12 cell page-contents-15 content">
                <p class="tag">
                {{ currentResearchPaper.tag }}
                </p>
              </div>
            </div>

            <div class="grid-x">
              <div
                v-html="currentResearchPaper.description"
                class="small-12 medium-12 cell page-contents-15 content">
              </div>
            </div>

          </div>
          <div class="modal-footer">
            &nbsp;<div class="grid-container full">
            <div class="grid-x">
              <div class="small-12 medium-12 cell text-left page-contents-15">

              </div>
            </div>
          </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import RareStandardButton from 'rare-patternlab/buttons/RareStandardButton';
import RareModalCloseIconLarge from 'rare-patternlab/icons/navigation/RareModalCloseIconLargeBlack';
import RareModalCloseIconMedium from 'rare-patternlab/icons/navigation/RareModalCloseIconMediumBlack';


export default {
  name: 'navigationModal',
  components: {
    'rare-apply-now-button': RareStandardButton,
    'rare-modal-close-icon-medium': RareModalCloseIconMedium,
    'rare-modal-close-icon-large': RareModalCloseIconLarge,
  },
  data() {
    return {
      currentResearchPaper: null,
      researchData: {
        class: {
          title: 'Class, Race and Graduate Recruitment: Best Practices',
          subtitle: '',
          date: 'December 2011',
          author: 'Naomi Kellman and Raphael Mokades',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/class-race-graduate-recruitment.png')],
          pdf: ['/static/research/2011_Class_race_and_graduate_recruitment.pdf'],
          tag: '',
          description: 'An ambitious study of the success of candidates from different socioeconomic and ethnic backgrounds, examining existing recruitment practices and graduate experiences first hand. Based on our findings, we give eight recommendations for fairness in graduate recruitment.',
        },
        five: {
          title: 'Five Years On',
          subtitle: '',
          date: 'December 2012',
          author: 'Naomi Kellman and Raphael Mokades',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/five-years-on.png')],
          pdf: ['/static/research/2012_Five_Years_On.pdf'],
          tag: '',
          description: 'This piece of research is an investigation into the retention of ethnic minority graduates in the first five years of their careers. It uses both quantitative and qualitative data to examine ethnic minority graduate employee retention, culminating in a series of recommendations both to organisations and to ethnic minority graduates beginning their careers.',
        },
        social: {
          title: 'Social Mobility in Graduate Recruitment',
          subtitle: 'Potential not polish: what graduate recruiters can learn from contextual admissions to universities',
          date: 'December 2013',
          author: 'Joshua Oware, Raphael Mokades and Mirela Ivanova',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/social-mobility-grad-recruitment.png')],
          pdf: ['/static/research/2013_Social_Mobility_in_Graduate_Recruitment.pdf'],
          tag: '',
          description: 'The UK has continued to see widening economic inequality and decreasing social mobility since about 1980. We believe this, so far as we can ascertain, to be the first report linking social theory, university admissions and the practice of social mobility in relation to graduate recruitment.',
        },
        bias: {
          title: 'Unconscious Bias in Graduate Recruitment',
          subtitle: 'A collection of essays',
          date: 'December 2014',
          author: 'Joshua Oware FRSA',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/unconscious-bias-grad-recruitment.png')],
          pdf: ['/static/research/2014_UB_in_graduate_recruitment.pdf'],
          tag: '',
          description: 'A fresh take on unconscious bias in this three-part essay series, covering the emergence of Rare’s concern with unconscious bias; examining the idea of background and our developing understanding of the unconscious; and asking the question of ‘what are we looking for?’ with analysis of the recent, and under-researched, emergence of video interviews.',
        },
        mobility: {
          title: 'Social Mobility in Graduate Recruitment',
          subtitle: 'Big data and the CRS three years on',
          date: 'April 2016',
          author: 'Gjeta Gjyshinca, Chetan Halai, Raphael Mokades, Joshua Oware, Luxmmi Varathan',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/social-mobility-in-graduate-recruitment.png')],
          pdf: ['/static/research/2016_Social_Mobility_in_Graduate_Recruitment_three_years_on.pdf'],
          tag: '',
          description: 'This report is in three sections: the first explores 54,000 lines of CRS data; the second retrospectively analyses the demography of previous years’ hires at a number of our CRS clients; and the third sets out Rare’s standardised contextual recruitment measure for 2016 onwards.',
        },
        aus: {
          title: 'Contextual Recruitment in Australia',
          subtitle: 'Why recruiters have a role to play in promoting social mobility, and how contextual data can help to identify hidden talent',
          date: 'June 2016',
          author: '. Gjeta Gjyshinca',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/contextual-recruitment-aus.png')],
          pdf: ['/static/research/2016_Contextual_Recruitment_in_Australia.pdf'],
          tag: '',
          description: 'The pioneering use of contextual recruitment is spreading from the UK to businesses around the planet. This report examines why Australia is a natural fit, given the widening gap between rich and poor, as well as the educational inequality evident in Australian schools.',
        },
        ausYear: {
          title: 'Contextual Recruitment in Australia',
          subtitle: 'One year on',
          date: 'February 2017',
          author: '',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/contextual-recruitment-aus-one-year-on.png')],
          pdf: ['/static/research/2017_Contextual_Recruitment_in_Australia-One_year_on.pdf'],
          tag: '',
          description: 'This brief report looks at applications processed by the early adopters of the Contextual Recruitment System in Australia ad provides detailed analysis on who is applying to top firms.',
        },
        field: {
          title: 'Level Playing Field',
          subtitle: 'Super scools, social mobility and star out performers',
          date: 'May 2017',
          author: 'Naomi Kellman, Raphael Mokades and Luxmmi Varathan',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/level-playing-field.png')],
          pdf: ['/static/research/2017_Level_playing_field.pdf'],
          tag: '',
          description: 'A deep dive into our Contextual Recruitment System reveals the surprising effect of grammar schools, what performance indexes really mean, and evidence of the extent to which refugees outperform their peers.',
        },
        measures: {
          title: 'Measures That Matter',
          subtitle: 'Analysing disadvantage and identifying outperformance.',
          date: 'September 2018',
          author: 'Naomi Kellman, Raphael Mokades, Dr Jonathan Ward',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/measures-that-matter.png')],
          pdf: ['/static/research/2018_measures_that_matter.pdf'],
          tag: '',
          description: 'Three years after the launch of Rare\'s Contextual Recruitment System, hundreds of thousands of data points later, we have a much more granular view of who applies for top graduate jobs. This report explores the medium-term impact of contextualising achievement and points to how to broaden the collective applicant pool in the next few years.',
        },
        staygap: {
          title: 'Closing the Ethnicity Stay Gap - the summary',
          subtitle: 'Why firms are failing to retain ethnic minority talent and what to do about it',
          date: 'March 2020',
          author: 'Dr Jon Ward, Kura Dione-Warren, Raph Mokades',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/closing_the_ethnicity_stay_gap.png')],
          pdf: ['/static/research/2020_Closing_the_ethnicity_staygap_v2.pdf'],
          tag: '',
          description: '',
        },
        oneofus: {
          title: 'One of us?  - The Summary',
          subtitle: 'The experience of Jews and Muslims in City Law',
          date: 'November 2021',
          author: 'Ayesha Burnett, Raph Mokades',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/one-of-us-cover.png')],
          pdf: ['/static/research/Religious_Heritage_Research-executive_summary.pdf'],
          tag: '',
          description: '',
        },
        expcitylaw: {
          title: 'Included?',
          subtitle: 'The experience of British Bangladeshis and Pakistanis in City Law',
          date: 'June 2024',
          author: 'Naomi Kellman',
          image: [
            // eslint-disable-next-line
            require('@/assets/img/research/experience-of-british-bangladeshis-and-pakistanis-in-city-law.png'),
            // eslint-disable-next-line
            require('@/assets/img/research/experience-of-british-bangladeshis-and-pakistanis-in-city-law-summary.png'),
          ],
          pdf: [
            '/static/research/The_Experience_of_British_Bangladeshis_and_Pakistanis_in_City_Law_Full_Report_June_2024.pdf',
            '/static/research/The_Experience_of_British_Bangladeshis_and_Pakistanis_in_City_Law_Summary_June_2024.pdf',
          ],
          tag: '',
          description: 'An in-depth examination of the challenges faced by British Bangladeshis and Pakistanis in City Law, highlighting how race, class and religion intersect, and providing useful tips for employers on how to create an inclusive workplace for people of different ethnicities, socioeconomic backgrounds and faiths.',
        },
        highachievingblackstudents: {
          title: 'High Achieving Black Students',
          subtitle: 'A snapshot',
          date: 'December 2009',
          author: 'Nussaibah Younis and Raphael Mokades',
          // eslint-disable-next-line
          image: [require('@/assets/img/research/high-achieving-black-students.png')],
          pdf: ['/static/research/2009_High_Achieving_Black_Students.pdf'],
          tag: '',
          description: 'A comprehensive insight into the lives of elite Black students in the UK, this research examines the experiences, trials and tribulations of top Black students and offers helpful recommendations to employers seeking to recruit them.',
        },
      },
    };
  },
  props: {
    researchPaperToShow: {
      type: String,
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.$emit('closeResearchModal');
    },
    watchForEsc(key) {
      if (key.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  mounted() {
    this.$refs.modal.focus();
  },
  created() {
    this.currentResearchPaper = this.researchData[this.researchPaperToShow];
    document.addEventListener('keyup', this.watchForEsc);
  },
  destroyed() {
    document.removeEventListener('keyup', this.watchForEsc);
  },

};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .modal-mask {
    position: fixed;
    z-index: 9990;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    max-height: 100vh;
    -webkit-backdrop-filter: blur(30px);
    backdrop-filter: blur(30px);
    transition: opacity .3s ease;
    background-color: rgba(255,255,255, .95);
    overflow: hidden;
  }

  .modal-wrapper {
    vertical-align: middle;
    opacity: 1;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9991;
    overflow-y: scroll;
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    padding: 0;
    background-color: transparent;
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    opacity: 1;
  }


  .modal-body {
    margin: 0 0 90px 0;
  }

  .modal-default-button {
    float: right;
  }

  /* NAVIGATION TEXT STYLES FOR BOTH SIZES */

  h1 {
    color: $main-text;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  p, h2, h3 {
    color: $main-text;
  }

  p {
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  @media only screen and (max-width: 640px)  {


    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 8px;
      top: 22px;
      z-index: 9995;
    }

    h1 {
      font-size: 28px;
      line-height: 1.33;
      margin: 80px 0 6px 0;
    }

    p.info {
      line-height: 1.52;
      font-size: 16px;
    }

    p.tag {
      line-height: 1.2;
      font-size: 21px;
      font-weight: bold;
    }

    p.content {
      line-height: 1.78;
      font-size: 18px;
    }

    .research-image {
      height: 290px;
      margin-bottom: 25px;
      margin-right: 20px;
    }

  }

  @media only screen and (min-width: 641px)  {
    .rareModalCloseIcon {
      cursor: pointer;
      position: absolute;
      right: 124px;
      top: 84px;
      z-index: 9995;
    }

    h1 {
      font-size: 56px;
      line-height: 1.2;
      margin: 105px 0 20px 0;
      text-transform: capitalize;
    }

    p.info {
      line-height: 1.52;
      font-size: 21px;
    }

    p.tag {
      line-height: 1.5;
      font-size: 24px;
      font-weight: bold;
    }

    p.content {
      line-height: 1.78;
      font-size: 18px;
    }

    .research-image {
      height: 290px;
      margin-bottom: 35px;
      margin-right: 20px;
    }

  }

</style>

<style type="text/css">

  .content {
    color: #343c43;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-align: left;
  }

  @media only screen and (max-width: 640px)  {

    .content {
      line-height: 1.78;
      font-size: 15px;
    }

  }

  @media only screen and (min-width: 641px)  {


    .content {
      line-height: 1.78;
      font-size: 18px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/carousels/researchCarouselModal.vue